// extracted by mini-css-extract-plugin
export default {"top":"Tickets_top__R9Jwv","name":"Tickets_name__5NTET","exposition":"Tickets_exposition__WZLeO"};